
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      export default {
  data() {
    return {
      user: window.identity,
      enable_notification: window.identity.enable_notification
    };
  },

  mounted() {},

  methods: {
    readTerms() {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;
      app.request({
        url: Url.to("data/terms-and-conditions"),
        method: "GET",
        preloader: true,
        progress: false,
        data: {},
        success: function (data, status, xhr) {
          console.log(data);
          $$("#dynamic-popup .navbar .title").html("GDPR Consent");
          $$("#dynamic-popup .navbar .title-large-text").html("GDPR Consent");
          $$("#dynamic-popup #dynamic-popup-content").html(data['terms']);
          app.loginScreen.open("#dynamic-popup", true);
        }
      });
    },

    withdrawConsent(e) {
      e.preventDefault();
      e.stopPropagation();
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;
      setTimeout(() => {
        var acceptTnc = $$("#gdpr-consent").is(":checked");

        if (acceptTnc) {
          app.dialog.create({
            title: "<i class='material-icons text-color-red'>warning</i>",
            content: "Are you sure you want to withdraw your consent? " + "By doing so, will remove all locations from your account and you won't be able to add " + "any new location unless you consent again to the GDPR terms.",
            verticalButtons: true,
            buttons: [{
              text: 'Confirm',

              //color: 'red',
              onClick() {
                $$("#gdpr-consent").prop("checked", false);
              }

            }, {
              text: 'Cancel',
              color: 'red',

              onClick() {}

            }]
          }).open();
        } else {
          $$("#gdpr-consent").prop("checked", true);
        }
      }, 50);
    },

    changeNotification(e) {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7;
      self.enable_notification = $$("#settings-enable-notification").is(":checked");
      $$("#settings-enable-repair-notification").prop("checked", self.enable_notification);
      $$("#settings-enable-maintenance-notification").prop("checked", self.enable_notification);
      $$("#settings-enable-contract-notification").prop("checked", self.enable_notification);
      self.$update();
    },

    updateSettings() {
      var self = this;
      var app = self.$app;
      var $$ = self.$dom7; // self.$app.dialog.confirm("Are you sure you want to save these settings?", function () {

      var gdpr_consent = $$("#gdpr-consent").is(":checked");
      var enable_notification = $$("#settings-enable-notification").is(":checked");
      var enable_repair_notification = $$("#settings-enable-repair-notification").is(":checked");
      var enable_maintenance_notification = $$("#settings-enable-maintenance-notification").is(":checked");
      var enable_contract_notification = $$("#settings-enable-contract-notification").is(":checked");
      self.$app.request({
        url: Url.to("user/gdpr-consent-multi-db"),
        method: "POST",
        data: {
          gdpr_consent: gdpr_consent ? 1 : 0,
          enable_notification: enable_notification ? 1 : 0,
          enable_repair_notifications: enable_repair_notification ? 1 : 0,
          enable_maintenance_notifications: enable_maintenance_notification ? 1 : 0,
          enable_contract_notifications: enable_contract_notification ? 1 : 0
        },
        preloader: true,
        progress: true,
        success: function (data, status, xhr) {
          //console.log(data, status, xhr);
          window.reloadIdentity(true, function () {
            self.$router.back();
          });
        }
      }); // });
    }

  },
  id: '04a848eaaa',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '\n    <div class="page navbar-extra-large no-toolbar" data-name="manage-consent">\n        <!-- Top Navbar -->\n        <div class="navbar navbar-large navbar-extra-large">\n            <div class="navbar-bg"></div>\n            <div class="navbar-inner sliding">\n                <div class="left">\n                    <a href="#" class="link back icon-only">\n                        <i class="icon icon-back"></i>\n                    </a>\n                </div>\n                <div class="title">Manage Consent</div>\n                <div class="right">\n                </div>\n                <div class="title-large">\n                    <div class="title-large-text">\n                        Account\n                        <div class="subtitle-text">Manage Consent</div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class="page-content">\n            ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.user.gdpr_message, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n            <div class="block text-color-red">\n                ';
          r += c(ctx_2.user.gdpr_message, ctx_2);
          r += '\n            </div>\n            ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n            <div class="list links-list">\n                <ul>\n                    <li>\n                        <a @click="readTerms" href="#">Review GDPR Consent</a>\n                    </li>\n                </ul>\n            </div>\n            <div class="list media-list no-hairlines">\n                <ul>\n                    <li>\n                        <label class="item-content padding-horizontal">\n                            <div class="item-inner no-padding">\n                                <div class="item-text text-color-black" style="--f7-list-item-text-max-lines: 10">\n                                    I consent to register and use Mitsulift App for repair or maintenance\n                                    requests and to the processing of my data for this purpose\n                                </div>\n                            </div>\n                            <div class="item-after">\n                                <label class="toggle toggle-init">\n                                    <input @click="withdrawConsent" type="checkbox" id="gdpr-consent" value="1"\n                                           ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.user.gdpr_consent, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += 'checked';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '>\n                                    <span class="toggle-icon"></span>\n                                </label>\n                            </div>\n                        </label>\n                    </li>\n                </ul>\n            </div>\n            <div class="list media-list no-hairlines no-margin-bottom" style="--f7-typography-padding: 20px;">\n                <ul>\n                    <li>\n                        <label class="item-content padding-horizontal">\n                            <div class="item-inner no-padding">\n                                <div class="item-text text-color-black" style="--f7-list-item-text-max-lines: 10">\n                                    I would like and consent to receive informational emails and promotions from Mitsulift.\n                                </div>\n                            </div>\n                            <div class="item-after">\n                                <label class="toggle toggle-init">\n                                    <input type="checkbox" id="settings-enable-notification" name="enable_notification" value="1"\n                                           ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.user.enable_notification, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += 'checked';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += ' @change="changeNotification" />\n                                    <span class="toggle-icon"></span>\n                                </label>\n                            </div>\n                        </label>\n                    </li>\n                </ul>\n            </div>\n\n            <div class="list no-margin-top padding-left ';
      r += Template7Helpers.unless.call(ctx_1, ctx_1.enable_notification, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += 'disabled';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '"\n                 style="--f7-typography-padding: 20px;padding-left: 65px !important;--f7-toggle-width: 45px;--f7-toggle-height: 25px;padding-right: 5px">\n                <ul>\n                    <li>\n                        <label class="item-content padding-horizontal">\n                            <div class="item-inner">\n                                <div class="item-text text-color-black" style="--f7-list-item-text-max-lines: 10">\n                                    Repair in progress\n                                </div>\n                            </div>\n                            <div class="item-after">\n                                <label class="toggle toggle-init">\n                                    <input type="checkbox" id="settings-enable-repair-notification" name="enable_repair_notifications" value="1"\n                                           ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.user.enable_repair_notifications, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += 'checked';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '>\n                                    <span class="toggle-icon"></span>\n                                </label>\n                            </div>\n                        </label>\n                    </li>\n                    <li>\n                        <label class="item-content padding-horizontal">\n                            <div class="item-inner">\n                                <div class="item-text text-color-black" style="--f7-list-item-text-max-lines: 10">\n                                    Maintenance in progress\n                                </div>\n                            </div>\n                            <div class="item-after">\n                                <label class="toggle toggle-init">\n                                    <input type="checkbox" id="settings-enable-maintenance-notification" name="enable_maintenance_notifications" value="1"\n                                           ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.user.enable_maintenance_notifications, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += 'checked';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '>\n                                    <span class="toggle-icon"></span>\n                                </label>\n                            </div>\n                        </label>\n                    </li>\n                    <li>\n                        <label class="item-content padding-horizontal">\n                            <div class="item-inner">\n                                <div class="item-text text-color-black" style="--f7-list-item-text-max-lines: 10">\n                                    Contract renewal\n                                </div>\n                            </div>\n                            <div class="item-after">\n                                <label class="toggle toggle-init">\n                                    <input type="checkbox" id="settings-enable-contract-notification" name="enable_contract_notifications" value="1"\n                                           ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.user.enable_contract_notifications, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += 'checked';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '>\n                                    <span class="toggle-icon"></span>\n                                </label>\n                            </div>\n                        </label>\n                    </li>\n                </ul>\n            </div>\n            <div class="block padding-horizontal">\n                <button @click="updateSettings" class="button button-large button-fill">Update</button>\n            </div>\n        </div>\n    </div>\n';
      return r;
    }(this);
  },

  styleScoped: false
};
    